import React, { useState, useEffect } from "react";
import { message, Upload, Button,Checkbox,Divider ,notification,TreeSelect  ,Col, InputNumber, Row, Slider, Space ,Switch} from "antd";

import DemoPie from "../Graphs/Pie/Pie"
import "./Analysis.scss";

export default function Analysis(props) {
  const { sliders,datos } = props;
  // console.log(sliders,'baluu')
  // console.log(sliders['time'],'baluues')
  const [aux, setAux] = useState(true);
  const style1 = {
    display: 'flex',
    flexDirection:'column',
    width: 350,
    marginRight:'50px'
  };

  var data = [
    {
      type: "Distance",
      value: parseInt(sliders['distance'])
    },
    {
      type: "Time",
      value: parseInt(sliders['time'])
    },
    {
      type: "Emissions",
      value: parseInt(sliders['emissions'])
    },
    {
      type: "% Completed",
      value: parseInt(sliders['ord_complet'])
    },
    {
      type: "% Veh. Filling",
      value: parseInt(sliders['veh_filling'])
    },
  ];

  var dataescen=[];
  var dataTable=[];
  var escenarios=[];
  var realData=[
   {cost_total_eur:datos[0][0]['cost_total_eur'],
   emissions_kgco2:datos[0][0]['emissions_kgco2'],
   tours_avgtime_min:datos[0][0]['tours_avgtime_min'],
   orders_completed:parseInt(datos[0][0]['orders_completed'])/parseInt(datos[0][0]['orders_total']),
   distance_total_km:datos[0][0]['distance_total_km']}
  ];

   for(var i=0;i<datos.length;i++){
    console.log('daots: ',datos)
     var aux1=parseInt(datos[i][0]['orders_completed'])/parseInt(datos[i][0]['orders_total'])
     
     realData[0].cost_total_eur= 
       (realData[0].cost_total_eur>parseFloat(datos[i][0]['cost_total_eur']))
       ?parseFloat(datos[i][0]['cost_total_eur'])
       :realData[0].cost_total_eur
     realData[0].emissions_kgco2=
       (realData[0].emissions_kgco2>parseFloat(datos[i][0]['emissions_kgco2']))
       ?parseFloat(datos[i][0]['emissions_kgco2'])
       :realData[0].emissions_kgco2 
     realData[0].tours_avgtime_min=
       (realData[0].tours_avgtime_min>parseFloat(datos[i][0]['tours_avgtime_min']))
       ?parseFloat(datos[i][0]['tours_avgtime_min'])
       :realData[0].tours_avgtime_min
     realData[0].orders_completed=
       (realData[0].orders_completed>aux1)
       ?aux1
       :realData[0].orders_completed
     realData[0].distance_total_km=
       (realData[0].distance_total_km>parseFloat(datos[i][0]['distance_total_km']))
       ?parseFloat(datos[i][0]['distance_total_km'])
       :realData[0].distance_total_km
   }
   
    for(var i=0;i<datos.length;i++){
     var aux1=parseInt(datos[i][0]['orders_completed'])/parseInt(datos[i][0]['orders_total'])
     dataescen.push({
       item:'% Orders Completed',
       user:`${i}`,
       score:Math.round(100*realData[0].cost_total_eur/datos[i][0]['cost_total_eur'])
     })
     dataescen.push({
       item:'Price',
       user:`${i}`,
       score:Math.round(100*realData[0].orders_completed/aux1)
     })
     dataescen.push({
       item:'CO2 Emissions',
       user:`${i}`,
       score:Math.round(100*realData[0].emissions_kgco2/datos[i][0]['emissions_kgco2'])
     })
     dataescen.push({
       item:'Distance',
       user:`${i}`,
       score:Math.round(100*realData[0].distance_total_km/datos[i][0]['distance_total_km'])
     })
     dataescen.push({
       item:'Time',
       user:`${i}`,
       score:Math.round(100*realData[0].tours_avgtime_min/datos[i][0]['tours_avgtime_min'])
     })
     var value=Math.round(parseInt(sliders['ord_complet'])* (realData[0].orders_completed/aux1)+
     parseInt(sliders['time'])*(realData[0].tours_avgtime_min/datos[i][0]['tours_avgtime_min'])+
     parseInt(sliders['emissions'])*(realData[0].emissions_kgco2/datos[i][0]['emissions_kgco2'])+
     parseInt(sliders['veh_filling'])*realData[0].cost_total_eur/datos[i][0]['cost_total_eur']+
     parseInt(sliders['distance'])*realData[0].distance_total_km/datos[i][0]['distance_total_km']);
     escenarios.push(
      {
        simul:i,
        value:value
      }
     )
   }

   escenarios.sort(function (a, b) {
    if (a.value > b.value) {
      return -1;
    } else if (a.value < b.value) {
      return +1;
    } else {
      return 0;
    }
  });
  var escen=[]
  var divider=1/escenarios.length;
  for(var i=0;i<escenarios.length;i++){
    var auxiliar=1-i*divider;
    escen.push(
      <h1 className="escenarioC" style={{backgroundColor: `rgb(34, 162, 25,${auxiliar})`}}>
        Escenario {escenarios[i].simul}: {escenarios[i].value}</h1>
     )
  }

  return (
    <div style={{
      display:'flex',
      flexFlow:'row',
      justifyContent:'space-between',
      alignItems:'center'
    }}>
       
          <Row>
            <Col>
              <h1>Filter: Distance</h1>
              <div style={style1}>
                <Slider 
                tooltip={(value) => `${value}%`}
                step={1}
                min={0}
                max={100}
                value={sliders['distance']}
                />
              </div>
              <h1>Filter: Time</h1>
              <div style={style1}>
                <Slider 
                tooltip={(value) => `${value}%`}
                step={1}
                min={0}
                max={100}
                value={sliders['time']}
                />
              </div>
              <h1>Filter: CO2 Emissions</h1>
              <div style={style1}>
                <Slider 
                tooltip={(value) => `${value}%`}
                step={1}
                min={0}
                max={100}
                value={sliders['emissions']}
                />
              </div>
              <h1>Filter: % Orders completed on time</h1>
              <div style={style1}>
                <Slider 
                tooltip={(value) => `${value}%`}
                step={1}
                min={0}
                max={100}
                value={sliders['ord_complet']}
                />
              </div>
              <h1>Filter: Price </h1>
              <div style={style1}>
                <Slider 
                tooltip={(value) => `${value}%`}
                step={1}
                min={0}
                max={100}
                value={sliders['veh_filling']}
                />
              </div>
            </Col>
            <DemoPie data={data}>
            </DemoPie>
          </Row>
          <div style={{
              display:'flex',
              flexFlow:'row',
              justifyContent:'space-between',
              alignItems:'center',
              width:'350px'
            }}>
            <div style={{
              display:'flex',
              flexFlow:'column',
              justifyItems:'center',
              alignItems:'center'
            }}>
              <h1>Más favorable</h1>
              <h2>↓</h2>
              <h1>Menos favorable</h1>
            </div>
            <Col>
            {escen}
            </Col>
          </div>
    </div>
  );

 
  
}
